module.exports = __webpack_public_path__ + "img/f.4dd46344.svg";